import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
//api
import { editPromoCode, getPromoCode } from 'api/invoice';
//helpers
import { capitalizeText } from 'helpers';
//components
import Title from 'components/backoffice/texts/title';
import PromoCodeForm from 'components/backoffice/forms/promoCodeForm';

const EditPromotionalCodes = () => {
  const { t } = useTranslation(['backoffice']);
  const { id } = useParams();
  const navigate = useNavigate();
  const [promoCode, setPromoCode] = useState({});
  const [loading, setLoading] = useState(false);
  const {setTitle} = useOutletContext()

  const getDetailsPromoCode = async () => {
    const { data, status } = await getPromoCode(id);
    if (status === 200) {
      setPromoCode(data);
    } else {
      setPromoCode([]);
    }
  };

  useEffect(() => {
    getDetailsPromoCode();
  }, []);

  useEffect(()=>{
    if(promoCode){
      setTitle(t('edit', {title: capitalizeText(promoCode?.title)}))
    }
    return () => {
      setTitle(''); 
    };
  },[promoCode, setTitle])

  const onSubmit = async (values) => {
    setLoading(true);
    const sendValues = {
      title: values.title,
      code: values.code,
      start: format(values.start, 'yyyy-MM-dd HH:mm'),
      end: format(values.end, 'yyyy-MM-dd HH:mm'),
      discount_percent: values.discount_percent ? values.discount_percent : null,
      discount_amount: values.discount_amount ? values.discount_amount : null,
      max_redemptions: values.max_redemptions,
      max_redemptions_per_user: values.max_redemptions_per_user,
      active: values.active,
      libraries: values.libraries
        ? values.libraries.map((el) => {
            return el?.value?.toString();
          })
        : [],
    };
    try {
      const { status } = await editPromoCode(sendValues, id);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate(-1);
      } else toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
    } catch (error) {
      console.error('Error en onEdit:', error);
    }
    setLoading(false);
  };

  return (
    <div>
      <Title text={t('editpromotionalcode')} />
      <PromoCodeForm onSubmit={onSubmit} promoCode={promoCode} loading={loading} isEditing={true} />
    </div>
  );
};

export default EditPromotionalCodes;
